import { jsx as _jsx } from "react/jsx-runtime";
import { useMeEmailIsVerifiedApi } from '../../api/me/meApi';
import { useOApiAuthReady } from '../../api/odata/util/useOApiAuthReady';
import { VerificationFlow } from './VerificationFlow';
/**
 * This component is responsible for verifying the user's email address.
 * This is automatically inserted into the page via the AppShell. We expose
 * it here to support having a dedicated `/verify` page.
 */
export const AccountVerification = () => {
    const { data: isVerified, isLoading } = useMeEmailIsVerifiedApi();
    const isAuthenticatedToApi = useOApiAuthReady();
    if (
    //Auth hasn't loaded yet
    !isAuthenticatedToApi ||
        //Refreshing the verification status
        isLoading ||
        //User is already verified
        isVerified ||
        //Data hasn't loaded yet
        isVerified === undefined) {
        return null;
    }
    return _jsx(VerificationFlow, {});
};
